import React, { createContext, useContext, useState } from 'react'

const EExpertContext = createContext()

export const EExpertProvider = ({ children }) => {
    const [sessionId, setSessionId] = useState(null)
    const [showEExpert, setShowEExpert] = useState(false)

    return (
        <EExpertContext.Provider value={{ sessionId, setSessionId, showEExpert, setShowEExpert }}>
            {children}
        </EExpertContext.Provider>
    )
}

export const useEExpert = () => {
    const context = useContext(EExpertContext)
    if (!context) {
        throw new Error('useEExpert must be used within an EExpertProvider')
    }
    return context
} 